unable to read source [project]/packages/core/src/devtools/getResetDebugSequence.ts